import * as reportConfigurationDefaults from './defaultReportConfigurations';
import * as reportConfigurationDefaultsActions from './defaults/reportConfigurationDefaultsActions';
import reportConfigurationDefaultsReducer from './defaults/reportConfigurationDefaultsReducer';
import reportConfigurationDefaultsSagas from './defaults/reportConfigurationDefaultsSagas';
import * as reportConfigurationDefaultsSelectors from './defaults/reportConfigurationDefaultsSelectors';
import * as reportConfigurationDefaultsTypes from './defaults/reportConfigurationDefaultsTypes';
import { useEnsureReportForTab } from './hooks/useEnsureReportForTab';
import { useIsConfigModified } from './hooks/useIsConfigModified';
import { useReduxConfig, useReduxConfigField } from './hooks/useReduxConfig';
import * as reportConfigurationsActions from './reportConfigurationsActions';
import * as reportConfigurationsConstants from './reportConfigurationsConstants';
import * as reportConfigurationsPersistence from './reportConfigurationsPersistence';
import reportConfigurationsReducer from './reportConfigurationsReducer';
import reportConfigurationsSagasBase from './reportConfigurationsSagas';
import * as reportConfigurationsSelectors from './reportConfigurationsSelectors';
import * as reportConfigurationsTypes from './reportConfigurationsTypes';
// Adjustment utilities are now part of reportFieldAvailability
import * as reportConfigurationsUtils from './utils/reportFieldAvailability';
import { getReportTitle } from './utils/reportTitle';

const { REDUCER_KEY } = reportConfigurationsTypes;
const { REPORT_CONFIGURATION_DEFAULTS_REDUCER_KEY } = reportConfigurationDefaultsTypes;
const reportConfigurationsSagas = [...reportConfigurationsSagasBase, ...reportConfigurationDefaultsSagas];

export {
  getReportTitle,
  REDUCER_KEY,
  REPORT_CONFIGURATION_DEFAULTS_REDUCER_KEY,
  reportConfigurationDefaults,
  reportConfigurationDefaultsActions,
  reportConfigurationDefaultsReducer,
  reportConfigurationDefaultsSelectors,
  reportConfigurationDefaultsTypes,
  reportConfigurationsActions,
  reportConfigurationsConstants,
  reportConfigurationsPersistence,
  reportConfigurationsReducer,
  reportConfigurationsSagas,
  reportConfigurationsSelectors,
  reportConfigurationsTypes,
  reportConfigurationsUtils,
  useEnsureReportForTab,
  useIsConfigModified,
  useReduxConfig,
  useReduxConfigField,
};
